import {Trans, useTranslation} from 'react-i18next';

import {C_PLATFORMS} from '@/constants';
import {SeparateChildren} from '@/utils/SeparateChildren';

import {AuthenticationWrapper} from '../../components/AuthenticationWrapper';

import {useViewModelProvider, ViewModelProvider} from './ViewModelContext';

import './styles';

const ParentRedirectionContent = () => {
  const {t} = useTranslation();

  const {handleClickBack, handleClickPlatform} = useViewModelProvider();

  return (
    <AuthenticationWrapper onBack={handleClickBack}>
      <SeparateChildren Separator={() => <div style={{height: '20px'}} />}>
        <section className="teen-redirect-card">
          <SeparateChildren Separator={() => <div style={{height: '20px'}} />}>
            <h2>
              <Trans i18nKey="parent_redirection_page.title" />
            </h2>

            <p className="teen-redirect-description">
              {t('parent_redirection_page.description')}
            </p>
            <img
              src="https://cdn.prod.website-files.com/6393514104d9044309a9e12e/66ba92b018b4b51208d5afa2_financial-future-image-mobile.avif"
              loading="lazy"
              alt=""
              className="sign-up-image"
            />
            <div className="sign-up-buttons-layout">
              <img
                src="https://cdn.prod.website-files.com/6393514104d9044309a9e12e/64555e7fe6fb577806e397a8_QR%20Download%20the%20App.svg"
                loading="lazy"
                alt=""
                className="image-qr"
              />

              <div className="w-layout-grid download-app vertical">
                <a
                  id="w-node-ea4c7a43-6427-1d04-f479-bac62476454d-0183e838"
                  href="https://app.adjust.com/10otse12"
                  target="_blank"
                  className="app-store-link w-inline-block"
                  onClick={() => handleClickPlatform(C_PLATFORMS.APPLE)}>
                  <img
                    src="https://cdn.prod.website-files.com/6393514104d9044309a9e12e/645560243d8642006c739a23_appstore.svg"
                    loading="lazy"
                    alt=""
                    className="app-store"
                  />
                </a>
                <a
                  id="w-node-ea4c7a43-6427-1d04-f479-bac62476454f-0183e838"
                  href="https://app.adjust.com/10dkycpz"
                  target="_blank"
                  className="google-play w-inline-block"
                  onClick={() => handleClickPlatform(C_PLATFORMS.GOOGLE)}>
                  <img
                    src="https://cdn.prod.website-files.com/6393514104d9044309a9e12e/6455602dcb110d5bed9e4ae7_googleplay.svg"
                    loading="lazy"
                    alt=""
                    className="image-45"
                  />
                </a>
              </div>
            </div>
          </SeparateChildren>
        </section>
      </SeparateChildren>
    </AuthenticationWrapper>
  );
};

const ParentRedirectionPage = () => (
  <ViewModelProvider>
    <ParentRedirectionContent />
  </ViewModelProvider>
);

export default ParentRedirectionPage;
